import { render } from "./Business.vue?vue&type=template&id=fe9c42e6"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"

import "./Business.vue?vue&type=style&index=0&id=fe9c42e6&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__